/*
 * Numbers as a chart shows them.
 *
 * Thousands separated, and anything from ten thousand up shortened, because a
 * legend row and an axis tick are both a few characters wide and "1,284,331" in
 * either of them pushes the drawing off the card.
 */

/*
 * Takes "12" as readily as 12.
 *
 * Not politeness: /statistic/categories maps every value through toString on
 * the way out, so its counts arrive as text, and a formatter that answered "0"
 * to anything that was not already a number printed a chart of zeroes in its
 * tooltip. recharts itself coerces, which is why the bars were the right length
 * while the number beside them was not.
 */
export function formatCount(value) {
    const number = typeof value === 'number' ? value : Number(value);

    if (!isFinite(number)) return '0';

    const abs = Math.abs(number);

    if (abs >= 1000000) return (number / 1000000).toFixed(1) + 'M';
    if (abs >= 10000) return Math.round(number / 1000) + 'K';

    return number.toLocaleString('en-US');
}

/** the share of a total, rounded - "0%" when there is no total to share */
export function formatShare(value, total) {
    if (!total) return '0%';
    return Math.round((Number(value) / Number(total)) * 100) + '%';
}



// WEBPACK FOOTER //
// ./src/components-new/general/charts/format.js